<template>
  <div>
    <v-container class="col-12 ml-0 mt-10 pl-0 pb-3">
      <v-row :style="searchHeight" class="mb-4 ml-0" cols="12">
        <v-col cols="2" class="pl-0">
          <v-select
            v-model="searchPayload.date_type"
            :items="dateTypeItems"
            label="Select"
            persistent-hint
            single-line
            :style="searchHeight"
            outlined
            dense
            class="pt-0"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-menu v-model="startMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.from"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.from"
              @input="startMenu = false"
              locale="ko"
              :max="searchPayload.to"
            ></v-date-picker> </v-menu
          >~
          <v-menu v-model="endMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.to"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchPayload.to" @input="endMenu = false" locale="ko" :min="searchPayload.from"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" class="pl-0">
          <v-select
            v-model="searchPayload.searchType"
            :items="searchTypeItems"
            label="선택하세요"
            persistent-hint
            single-line
            class="pt-0"
            outlined
            dense
            @change="changeSearchType"
          ></v-select>
        </v-col>
        <v-col cols="4" class="pr-0">
          <v-text-field
            v-model="searchPayload.searchValue"
            outlined
            dense
            class="mr-1"
            :placeholder="searchValuePlaceholder"
            @keypress.enter="execSearch(true)"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mb-0 ml-0" cols="12">
        <v-col cols="2" :style="searchHeight" class="pb-0 pt-6 pl-0">인증 회원 ID</v-col>
        <v-col cols="4">
          <v-text-field
            outlined
            dense
            class="mr-1"
            placeholder="아이디 입력"
            v-model="searchPayload.user_id"
            :style="{ width: '86%' }"
            @keypress.enter="execSearch(true)"
            hide-details
          ></v-text-field>
        </v-col>

        <v-col cols="2" :style="searchHeight" class="pb-0 pt-6 pl-0">인증 회원 이름</v-col>

        <v-col cols="4" class="pr-0">
          <v-text-field
            v-model="searchPayload.user_name"
            outlined
            dense
            class="mr-1"
            placeholder="인증 회원 이름 입력"
            @keypress.enter="execSearch(true)"
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mb-0 ml-0" cols="12">
        <v-col cols="2" :style="searchHeight" class="pb-0 pt-6 pl-0">인증 회원 전화번호</v-col>
        <v-col cols="4">
          <v-text-field
            outlined
            dense
            class="mr-1"
            placeholder="인증 회원 전화번호 입력"
            v-model="searchPayload.user_phone"
            :style="{ width: '86%' }"
            @keypress.enter="execSearch(true)"
            hide-details
          ></v-text-field>
        </v-col>

        <v-col cols="2" :style="searchHeight" class="pb-0 pt-6 pl-0">인증 회원 이메일</v-col>

        <v-col cols="4" class="pr-0">
          <v-text-field
            v-model="searchPayload.user_email"
            outlined
            dense
            class="mr-1"
            placeholder="인증 회원 이메일 입력"
            @keypress.enter="execSearch(true)"
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mb-0 ml-0" cols="12">
        <v-col cols="2" :style="searchHeight" class="pb-0 pt-6 pl-0">인증 상태</v-col>
        <v-col cols="4">
          <v-select
            v-model="searchPayload.cert_status"
            :items="authStateItems"
            label="Select"
            persistent-hint
            single-line
            class="pt-0"
            outlined
            dense
            :style="{ width: '86%' }"
          ></v-select>
        </v-col>

        <v-col cols="2" :style="searchHeight" class="pb-0 pt-6 pl-0">메모 여부</v-col>

        <v-col cols="4" class="pr-0">
          <v-select
            v-model="searchPayload.memo"
            :items="memoItems"
            label="Select"
            persistent-hint
            single-line
            class="pt-0"
            outlined
            dense
            :style="{ width: '99%' }"
          ></v-select>
        </v-col>
      </v-row>
      <div class="row justify-center mb-10">
        <v-btn large color="grey darken-4" class="white--text" width="100" @click.prevent="execSearch(true)">조회</v-btn>
        <v-btn large style="margin-left: 20px;" width="100" @click.prevent="resetSearch">초기화</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      textFileSize: {
        height: "50px",
        width: "110px",
      },
      searchHeight: {
        height: "50px",
      },
      dateTypeItems: [
        { text: "인증일자", value: "activated_at" },
        { text: "승인일자", value: "approved_at" },
      ],
      searchTypeItems: [
        { text: "정품인증코드", value: "authcode" },
        { text: "상품명", value: "productName" },
        { text: "상품코드", value: "productCode" },
        { text: "상품번호", value: "productNo" },
      ],
      searchMemberTypeItems: [{ text: "인증 회원 이름", value: "memberName" }],
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      modal: false,
      startMenu: false,
      endMenu: false,
      searchValuePlaceholder: "정품인증코드 입력",

      searchPayload: {
        date_type: "activated_at",
        from: "",
        to: "",
        serial_number: "",
        product_name: "",
        product_code: "",
        product_number: "",
        user_id: "",
        user_name: "",
        user_hp: "",
        user_email: "",
        offset: 0,
        limit: 20,
        searchType: ["imweb", "shopby"].includes(this.mallType) ? "productNo" : "authcode",
        cert_status: "",
        memo: "",
      },
      authStateItems: [
        { text: "전체", value: "" },
        //  { text: "미인증", value: "inactivated" },
        { text: "인증완료", value: "activated" },
        { text: "승인완료", value: "approved" },
        // { text: "분실", value: "lost" },
      ],
      memoItems: [
        { text: "전체", value: "" },
        { text: "메모 있음", value: "enabled" },
        { text: "메모 없음", value: "disabled" },
      ],
    };
  },
  mixins: [CommonMixin],
  created: function() {
    if (this.mallType === "imweb") {
      // this.searchTypeItems delete productCode
      this.searchTypeItems = this.searchTypeItems.filter((item) => item.value !== "productCode");
      this.searchPayload.searchType = "productNo";
      this.searchValuePlaceholder = "상품번호 입력";
    } else {
      this.searchTypeItems = this.searchTypeItems.filter((item) => item.value !== "productNo");
    }
    this.eventHub.$on("execSearch", this.execSearch);
    this.eventHub.$on("getPayload", this.getPayload);
  },
  methods: {
    /**
     * 검색
     */
    execSearch: function(init = false) {
      this.$nextTick(function() {
        if (init === true) {
          this.$parent.$refs.listComponent.options = {
            page: 1,
            itemsPerPage: this.searchPayload.limit,
          };
        } else {
          let { page, itemsPerPage } = this.$parent.$refs.listComponent.options;
          this.searchPayload.offset = (page - 1) * itemsPerPage;
          this.searchPayload.limit = itemsPerPage;
          this.getProductList();
        }
      });
    },
    resetSearch: function() {
      this.searchPayload = {
        product_name: "",
        product_number: "",
        cert_status: "",
        search_type: "product_code",
        search_value: "",
        range_type: "created_at",
        from: "",
        to: "",
        user_id: "",
        user_phone: "",
        user_email: "",
        user_name: "",
        limit: 20,
        offset: 0,
        date_type: "activated_at",
        searchType: ["imweb", "shopby"].includes(this.mallType) ? "productNo" : "authcode",
        searchValue: "",
        memo: "",
      };
      let befor1Month = new Date();
      befor1Month.setMonth(befor1Month.getMonth() - 1);

      let toDay = new Date();
      this.searchPayload.from = M.yyyymmdd(befor1Month);
      this.searchPayload.to = M.yyyymmdd(toDay);
    },
    /**
     * 검색내용 훔치기
     */
    getPayload: function() {
      return this.searchPayload;
    },
    /**
     * 상품 가져오기
     */
    getProductList: async function() {
      await this.waitForShopNo();
      this.$parent.$refs.listComponent.tableLoading = true;

      this.searchPayload.serial_number = "";
      this.searchPayload.product_name = "";
      this.searchPayload.product_code = "";
      this.searchPayload.product_number = "";
      //this.searchPayload.user_name = "";
      //this.searchPayload.user_id = "";

      delete this.searchPayload["user_hp"];

      if (this.searchPayload.searchType == "authcode") {
        this.searchPayload.serial_number = this.searchPayload.searchValue;
      }
      if (this.searchPayload.searchType == "productName") {
        this.searchPayload.product_name = this.searchPayload.searchValue;
      }
      if (this.searchPayload.searchType == "productCode") {
        this.searchPayload.product_code = this.searchPayload.searchValue;
      }
      if (this.searchPayload.searchType == "productNo") {
        this.searchPayload.product_number = this.searchPayload.searchValue;
      }

      let data;
      try {
        data = await M.api(M.entry("/get/user/search"), this.searchPayload);
      } catch (e) {
        //console.log(e);
      }
      if (data.serials.length > 0) {
        for (let i = 0; i < data.serials.length; i++) {
          for (let j = 0; j < data.serials[i].auth_item.length; j++) {
            let value = data.serials[i].auth_item[j].value;

            if (Array.isArray(value)) {
              // 체크 박스 ( 배열 ) 처리
              data.serials[i].auth_item[j].value = value.join(", ");
            } else if (value == "--") {
              // 날짜 미입력 했을때
              data.serials[i].auth_item[j].value = "";
            } else if (value) {
              let idx = value.indexOf("https://shoplus-images");
              if (idx > -1) {
                data.serials[i].auth_item[j].type = "file";
              }
            } else {
              //
            }
          }
          if (data.serials[i].auth_member_info) {
            if (data.serials[i].auth_member_info.hp) {
              let phone = data.serials[i].auth_member_info.hp.replace(/[^0-9]/g, "");
              /*
              .replace(
                /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
                "$1-$2-$3"
              );
              */

              data.serials[i].auth_member_info.hp = phone;
            }
          }
        }
      }

      this.$parent.$refs.listComponent.setAuthMemberList(data);
    },
    /**
     * 검색어 타입 수정
     **/
    changeSearchType: function() {
      let placeholderData = {
        authcode: "코드명 입력",
        productName: "상품명 입력",
        productCode: "상품코드 입력",
        productNo: "상품번호 입력",
      };
      this.searchValuePlaceholder = placeholderData[this.searchPayload.searchType];
    },
  },
  mounted: function() {
    let befor1Month = new Date();
    befor1Month.setMonth(befor1Month.getMonth() - 1);
    let toDay = new Date();
    /**
     * 정품인증 코드 생성 -> 확인하러가기 createAuth 파라메터
     */
    if (this.$route.query.createAuth && this.$route.query.createAuth == "Y") {
      this.searchPayload.from = M.yyyymmdd(toDay);
      this.searchPayload.cert_status = "inactivated";
    } else {
      this.searchPayload.from = M.yyyymmdd(befor1Month);
    }
    this.searchPayload.to = M.yyyymmdd(toDay);
  },
  computed: {
    mallType() {
      return this.$store.state.mallType;
    },
  },
};
</script>
